import { getMarker, stripMarkerDecoration, singleMarkerDecorator, multipleMarkerDecorator } from '../util/getMarker';

const removeOldMarkers = (listOfMarkers, results, map, removalFn) => {
  const markersToRemove = [];
  listOfMarkers.forEach((marker, idx) => {
    const matchingResult = results.findIndex(x => x.communityId === marker.communityId);
    if (matchingResult > -1) {
      marker.setMap(map);
    } else {
      markersToRemove.push(idx);
    }
  });
	markersToRemove.forEach(removalFn);
	markersToRemove.reverse().forEach((marker, idx) => {
		listOfMarkers.splice(marker, 1);
	});
};

const decorateMarker = args => {
  const { item, latLngGroups, activeMarker, marker } = args;
  const { latitude, longitude } = item;
  const latLngKey = `${latitude},${longitude}`;
  if (latLngGroups && latLngGroups[latLngKey] && latLngGroups[latLngKey].length > 1) {
    multipleMarkerDecorator({ item, latLngGroups, activeMarker, marker });
  } else {
    singleMarkerDecorator({ item, activeMarker, marker });
  }
};

const manageNonMpcMarkers = args => {
  const { nonMpcResults, currentMarkers, activeMarker, map, onMarkerClick, latLngGroups } = args;
  nonMpcResults.forEach(item => {
    const existingMarkerIdx = currentMarkers.findIndex(x => x.communityId === item.communityId);
    if (existingMarkerIdx === -1) {
      const marker = getMarker({ item, activeMarker, latLngGroups });
      marker.listener = marker.addListener('click', () => {
        onMarkerClick({ result: item, groups: latLngGroups }, marker);
      });
      stripMarkerDecoration(marker);
      decorateMarker({ item, latLngGroups, activeMarker, marker });
      currentMarkers.push(marker);
    } else {
      const marker = currentMarkers[existingMarkerIdx];
      google.maps.event.removeListener(marker.listener);
      marker.listener = marker.addListener('click', () => {
        onMarkerClick({ result: item, groups: latLngGroups }, marker);
      });
      stripMarkerDecoration(marker);
      decorateMarker({ item, latLngGroups, activeMarker, marker });
    }
  });

  removeOldMarkers(currentMarkers, nonMpcResults, map, markerToRemove => {
    if (currentMarkers[markerToRemove]) {
      currentMarkers[markerToRemove].setMap(null);
    }
  });
};

export { manageNonMpcMarkers };